import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Form,
} from "reactstrap";
import { CursoService } from "service/CursoService";
import { ContenidoService } from "service/ContenidoService";
import FSelect from "components/Select/FSelect";

function ModalCurso({ isOpen, toggle, selectedCurso, onSave }) {
  const [curso, setCurso] = useState({
    titulo: "",
    modulo: "",
    descripcion: "",
    urlimagen: "",
    estado: "Borrador",
  });
  const [listModulos, setListModulos] = useState([]);
  const [loading, setLoading] = useState(false);

  const cursoService = new CursoService();
  const contenidoService = new ContenidoService();

  useEffect(() => {
    if (isOpen) {
      loadModulos();
      if (selectedCurso) {
        setCurso({
          ...selectedCurso,
          modulo: selectedCurso.modulo?._id || selectedCurso.modulo || "",
        });
      } else {
        setCurso({
          titulo: "",
          modulo: "",
          descripcion: "",
          urlimagen: "",
          estado: "Borrador",
        });
      }
    }
  }, [isOpen, selectedCurso]);

  const loadModulos = async () => {
    try {
      const res = await contenidoService.getModulos();
      setListModulos(res?.data || []);
    } catch (error) {
      console.error("Error cargando módulos:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurso((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    if (!curso.titulo || !curso.modulo) {
      alert("Título y Módulo son obligatorios");
      return;
    }

    setLoading(true);
    try {
      let res;
      if (curso._id) {
        res = await cursoService.updateCurso(curso);
      } else {
        res = await cursoService.addCurso(curso);
      }

      if (res?.confirmation === "success") {
        onSave();
        toggle();
      } else {
        alert(res?.message || "Error al guardar curso");
      }
    } catch (error) {
      console.error("Error guardando curso:", error);
      alert("Error de conexión al guardar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        {curso._id ? "Editar Curso" : "Nuevo Curso"}
      </ModalHeader>
      <ModalBody>
        <Form>
          <Row>
            <Col md="8">
              <FormGroup>
                <Label for="titulo">Título del Curso</Label>
                <Input
                  type="text"
                  name="titulo"
                  id="titulo"
                  value={curso.titulo}
                  onChange={handleChange}
                  placeholder="Ej: Matemática I"
                />
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <Label for="modulo">Módulo / Categoría</Label>
                <FSelect
                  name="modulo"
                  id="modulo"
                  value={curso.modulo}
                  onChange={handleChange}
                  options={listModulos.map((m) => ({ value: m._id, label: `${m.titulo} ${m.denominacion}` }))}
                  placeholder="Seleccione Módulo"
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <FormGroup>
                <Label for="descripcion">Descripción</Label>
                <Input
                  type="textarea"
                  name="descripcion"
                  id="descripcion"
                  value={curso.descripcion || ""}
                  onChange={handleChange}
                  rows="3"
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="8">
              <FormGroup>
                <Label for="urlimagen">URL Imagen (Google Drive ID)</Label>
                <Input
                  type="text"
                  name="urlimagen"
                  id="urlimagen"
                  value={curso.urlimagen || ""}
                  onChange={handleChange}
                  placeholder="ID de la imagen en Drive"
                />
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <Label for="estado">Estado</Label>
                <FSelect
                  name="estado"
                  id="estado"
                  value={curso.estado}
                  onChange={handleChange}
                  options={[
                    { value: "Publicado", label: "Publicado" },
                    { value: "Borrador", label: "Borrador" },
                    { value: "Oculto", label: "Oculto" },
                  ]}
                />
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSave} disabled={loading}>
          {loading ? "Guardando..." : "Guardar"}
        </Button>{" "}
        <Button color="secondary" onClick={toggle}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ModalCurso;
